import React from 'react';
import { Link as ScrollLink } from 'react-scroll';

const SimpleNavbar = () => {



  return (
    <nav className="bg-white shadow-md fixed w-full z-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between h-20 items-center">
          {/* Logo */}
          <div className="flex-shrink-0 items-center">
              <img className="h-16" src="/logos/CS_logo_full_straight.svg" alt="Codestart" />
          </div>
          
          {/* Right side - simplified action button - only show if not on signup page */}
          
            <div className="flex items-center">
              <ScrollLink
                to="contact-form-section"
                smooth={true}
                duration={800}
                offset={-100}
                className="px-6 py-2 bg-custom_tertiary text-custom_white text-lg font-semibold rounded-full shadow-md hover:text-black transition duration-200 no-underline cursor-pointer"
              >
                Loslegen!
              </ScrollLink>
            </div>

        </div>
      </div>
    </nav>
  );
};

export default SimpleNavbar;